import {
    CloseOutlined,
    DeleteFilled,
    EditFilled,
    PlusOutlined,
    SaveFilled,
    SearchOutlined,
    PrinterFilled,
    ClearOutlined,
    SaveOutlined,
    ArrowLeftOutlined
} from "@ant-design/icons";
import { Button, Card, Col, Popconfirm, Row, Space, Table } from "antd";
import { array, bool, element, func, string } from "prop-types";
import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BUTTON_SIZE, TABLE_SIZE } from "../../common/ThemeConstants";
import FormButton from "../general/FormButton";
import FormContainer from "../general/FormContainer";
import "./BasicFormComponent.css";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import Title from "antd/lib/typography/Title";

const BasicFormComponentInvTransaction = (props) => {
    const {
        reset,
        handleReset,
        handleSave,
        formTitle,
        searchPanel,
        searchSubmit,
        formPanel,
        tableColumn = [],
        tableRows = [],
        tableLoading = false,
        onFormSave,
        formWidth,
        hideAction = false,
        hideEdit = false,
        hideDelete = false,
        actionID,
        editRow,
        deleteRow,
        formLoading,
        fields,
        onFormClose,
        onUpdate,
        onFormOpen,
        hideAddButton = false,
        hideSearchButton = false,
        crudTitle,
        showSubmit = false,
        submitForm,
        submitFormLoading,
        disableSaveAndSubmit = false,
        disableForm = false,
        report = false,
        viewReport,
        componentRefPrint,
        isCancel = false,
        onCancel,
        onPaginationChange, // Custom pagination handler
        paginationConfig, // Pagination configuration object
        baseRoute, // Base route for navigation (e.g., "/openingInventory")
        createRoute, // Full route for create page (e.g., "/openingInventory/create")
        editRoute, // Route template for edit page (e.g., "/openingInventory/edit/:id")
        pageMode = "listing", // "listing" or "transaction" - determines which UI to render
        isEditMode = false, // For transaction mode - indicates if editing existing record
        transactionDetailsColumns = [], // Columns for transaction details table
        transactionDetailsRows = [], // Rows for transaction details table
        onAddDetail, // Handler for adding transaction detail
        onRemoveDetail, // Handler for removing transaction detail
        onCancelForm, // Handler for cancel button in transaction mode
        addDetailEntryPanel, // Optional: React node with dropdowns (BarCode, ItemCode, Item) + Qty, Rate before Add Detail button
        showSave = true,
        showAddDetailButton = true,
    } = props;

    // const FeatureArray = useSelector(
    //     (state) => state.MenuFeatureReducer?.MenuFeature?.[0]?.Features
    // );
    // const AllFeatureArray = useSelector(
    //     (state) => state.MenuFeatureReducer?.MenuFeature?.[0]?.AllFeatures
    // );
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isUpdate, setIsUpdate] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const authReducerList = useSelector(a => a.authReducer);

    // Determine routes
    const getCreateRoute = () => {
        if (createRoute) return createRoute;
        if (baseRoute) return `${baseRoute}/create`;
        return "/";
    };

    const getEditRoute = (id) => {
        if (editRoute) {
            return editRoute.replace(":id", id);
        }
        if (baseRoute) {
            return `${baseRoute}/edit/${id}`;
        }
        return "/";
    };

    const handleAddNew = () => {
        if (onFormOpen) {
            onFormOpen();
        }
        setIsUpdate(false);
        navigate(getCreateRoute());
    };

    const handleUpdateAction = (id) => {
        if (editRow) {
            editRow((x) => (x = id));
        }
        setIsUpdate(true);
        navigate(getEditRoute(id));
    };

    const handleDeleteAction = (id, record) => {
        deleteRow && deleteRow(id, record);
    };

    // const FeatureExists = (array, value) => {

    //     if (!Array.isArray(array)) {
    //         return true;
    //     }

    //     if (array[0]?.FeatureExist === false || array.length === 0) {
    //         if (AllFeatureArray && AllFeatureArray.length > 0) {
    //             return false;
    //         }
    //         return true;
    //     }
    //     return array.includes(value.toUpperCase());
    // };

    useEffect(() => {
        !hideAction &&
            tableColumn &&
            tableColumn.push({
                title: "Action",
                key: "action",
                width: 120,
                render: (record) => {
                    return (
                        <Space size="middle">
                            {!hideEdit && (
                                // FeatureExists(FeatureArray, "edit") && (
                                <Button
                                    type="text"
                                    onClick={() => handleUpdateAction(record[actionID])}
                                    icon={<EditFilled className="blueIcon" />}
                                ></Button>
                                // )
                            )}
                            {!hideDelete &&
                                // FeatureExists(FeatureArray, "delete") &&
                                !record.IsSubmit && (
                                    <Popconfirm
                                        title="Are you surely want to delete this row?"
                                        onConfirm={() => handleDeleteAction(record[actionID], record)}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button
                                            type="text"
                                            icon={<DeleteFilled className="redIcon" />}
                                        ></Button>
                                    </Popconfirm>
                                )
                            }
                            {report && (
                                <ReactToPrint content={() => componentRefPrint.current}>
                                    <PrintContextConsumer>
                                        {({ handlePrint }) => (
                                            <Button
                                                type="text"
                                                onClick={() => viewReport(record, handlePrint)}
                                                icon={<PrinterFilled className="blueIcon" />}
                                            ></Button>
                                        )}
                                    </PrintContextConsumer>
                                </ReactToPrint>
                            )}
                        </Space>
                    );
                },
            });
        return () => {
            tableColumn.pop();
        };
    }, []);

    const handlePagination = (paginationInfo, filters, sorter) => {
        if (onPaginationChange) {
            onPaginationChange(paginationInfo, filters, sorter);
        }
    };

    const handleBackToList = () => {
        if (baseRoute) {
            navigate(baseRoute);
        } else {
            navigate(-1);
        }
    };

    const handleFormSubmit = (e, isSubmitFlag = false) => {
        e.preventDefault();
        if (onFormSave) {
            onFormSave(e, isEditMode ? 3 : 2, isSubmitFlag);
        }
    };

    const handleSaveClick = (e) => {
        e.preventDefault();
        handleFormSubmit({ preventDefault: () => { } }, false);
    };

    const handleSubmitClick = (e) => {
        e.preventDefault();
        handleFormSubmit({ preventDefault: () => { } }, true);
    };

    // Transaction Form Mode
    if (pageMode === "transaction") {
        return (
            <div style={{ margin: 5 }}>
                <Title level={3} style={{ color: "#017971", margin: 0 }}>
                    {isEditMode ? `${crudTitle || formTitle}` : `${crudTitle || formTitle}`}
                </Title>
                <Card>
                    {/* Header Section */}
                    <Row gutter={16} style={{ marginBottom: 16 }}>
                        <Col span={24}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: 16,
                                }}
                            >
                                {/* <Title level={3} style={{ color: "#017971", margin: 0 }}>
                                    {isEditMode ? `Edit ${crudTitle || formTitle}` : `Create ${crudTitle || formTitle}`}
                                </Title> */}
                                <Button
                                    icon={<ArrowLeftOutlined />}
                                    onClick={handleBackToList}
                                >
                                    Back to List
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    {/* Transaction Master Fields Section */}
                    {formPanel && (
                        <FormContainer
                            rowStyle={{ paddingTop: 20 }}
                            onSubmit={handleFormSubmit}
                        >
                            {formPanel}
                        </FormContainer>
                    )}
                </Card>
                <Card>
                    {/* Transaction Details Section */}
                    {transactionDetailsColumns && transactionDetailsColumns.length > 0 && (
                        <>
                            <Row gutter={16} style={{ marginTop: 20 }}>
                                <Col span={24}>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            alignItems: "flex-end",
                                            gap: 16,
                                            marginBottom: 16,
                                        }}
                                    >
                                        {addDetailEntryPanel}
                                        {onAddDetail && showAddDetailButton && (
                                            <Button
                                                type="dashed"
                                                icon={<PlusOutlined />}
                                                onClick={onAddDetail}
                                            >
                                                Add Detail
                                            </Button>
                                        )}
                                    </div>

                                    <Table
                                        columns={transactionDetailsColumns}
                                        dataSource={transactionDetailsRows}
                                        rowKey={(record, index) => index}
                                        pagination={false}
                                        scroll={{ x: 1500 }}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}

                    {/* Action Buttons Section */}
                    <Row gutter={16} style={{ marginTop: 20 }}>
                        <Col span={24}>
                            <Space>
                                {showSave && (
                                    <FormButton
                                        title={isEditMode ? "Update" : "Save"}
                                        type="primary"
                                        size={BUTTON_SIZE}
                                        htmlType="button"
                                        icon={<SaveFilled />}
                                        loading={formLoading}
                                        disabled={disableSaveAndSubmit}
                                        onClick={handleSaveClick}
                                    />)}
                                {showSubmit && (
                                    <FormButton
                                        title={isEditMode ? "Update and Post" : "Save and Post"}
                                        type="primary"
                                        size={BUTTON_SIZE}
                                        htmlType="button"
                                        icon={<SaveFilled />}
                                        loading={submitFormLoading}
                                        disabled={disableSaveAndSubmit}
                                        onClick={handleSubmitClick}
                                    />
                                )}
                                <FormButton
                                    title="Cancel"
                                    type="primary"
                                    size={BUTTON_SIZE}
                                    htmlType="button"
                                    icon={<CloseOutlined />}
                                    onClick={onCancelForm || handleBackToList}
                                />
                            </Space>
                        </Col>
                    </Row>
                </Card>
            </div>
        );
    }

    // Listing Mode (default)
    return (
        <div style={{ margin: 5 }}>
            <Title level={3} style={{ color: "#017971" }}>
                {formTitle}
            </Title>
            <div
                style={{
                    background: "white",
                    padding: 15,
                    boxShadow: "0 0 5px lightgray",
                    borderRadius: 2,
                }}
            >
                {searchPanel && (
                    <FormContainer
                        rowStyle={{ alignItems: "flex-end" }}
                        onSubmit={searchSubmit}
                    >
                        {searchPanel}
                        {!hideSearchButton && (
                            <Fragment>
                                <FormButton
                                    title="Search"
                                    type="primary"
                                    size={BUTTON_SIZE}
                                    colSpan={2}
                                    htmlType="submit"
                                    icon={<SearchOutlined />}
                                />
                                {reset && (
                                    <FormButton
                                        title="Reset"
                                        type="default"
                                        size={BUTTON_SIZE}
                                        colSpan={2}
                                        htmlType="button"
                                        onClick={handleReset}
                                        style={{ marginLeft: '0px', color: 'white' }}
                                        icon={<ClearOutlined />}
                                    />
                                )}
                            </Fragment>
                        )}
                    </FormContainer>
                )}
                <div
                    style={{ margin: "10px 0", borderTop: "1px solid lightgray" }}
                ></div>
                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    {
                        reset && (
                            <FormButton
                                title="Save"
                                type="primary"
                                size={BUTTON_SIZE}
                                colSpan={2}
                                htmlType="button"
                                onClick={handleSave}
                                icon={<SaveOutlined />}
                            />
                        )
                    }
                </div>
                {!hideAddButton && (
                    // FeatureExists(FeatureArray, "add") && (
                    <Row style={{ flexDirection: "row-reverse" }}>
                        <FormButton
                            type="primary"
                            icon={<PlusOutlined />}
                            title="Add New"
                            size={BUTTON_SIZE}
                            color="#01C2A6"
                            onClick={handleAddNew}
                        />
                    </Row>
                    // )
                )}

                {tableColumn && (
                    <div style={{ margin: "10px 0" }}>
                        <Table
                            columns={tableColumn}
                            rowKey={(record) => record[actionID]}
                            dataSource={tableRows}
                            className="no-broder-row"
                            pagination={paginationConfig || {
                                current: 1,
                                pageSize: 10,
                                pageSizeOptions: ['10', '20', '50', '100'],
                                showSizeChanger: true,
                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                            }}
                            loading={tableLoading}
                            size={TABLE_SIZE}
                            onChange={handlePagination}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

BasicFormComponentInvTransaction.propTypes = {
    formWidth: string,
    formTitle: string,
    searchPanel: element,
    searchSubmit: func,
    formPanel: element,
    tableLoading: bool,
    tableRows: array,
    tableColumn: array,
    onFormSave: func,
    isCancel: bool,
    onCancel: func,
    hideAction: bool,
    hideEdit: bool,
    hideDelete: bool,
    actionID: string,
    editRow: func,
    deleteRow: func,
    formLoading: bool,
    onUpdate: func,
    onFormClose: func,
    onFormOpen: func,
    hideAddButton: bool,
    crudTitle: string,
    showSubmit: bool,
    submitForm: func,
    submitFormLoading: bool,
    disableSaveAndSubmit: bool,
    disableForm: bool,
    report: bool,
    viewReport: func,
    componentRefPrint: func,
    baseRoute: string, // Base route for navigation
    createRoute: string, // Full route for create page
    editRoute: string, // Route template for edit page (with :id placeholder)
    pageMode: string, // "listing" or "transaction" - determines which UI to render
    isEditMode: bool, // For transaction mode - indicates if editing existing record
    transactionDetailsColumns: array, // Columns for transaction details table
    transactionDetailsRows: array, // Rows for transaction details table
    onAddDetail: func, // Handler for adding transaction detail
    onRemoveDetail: func, // Handler for removing transaction detail
    onCancelForm: func, // Handler for cancel button in transaction mode
    showSave: bool,
    showAddDetailButton: bool,
};

export default BasicFormComponentInvTransaction;
